import React, { useState } from "react";
import { Table, Label, Icon, Statistic, Checkbox } from "semantic-ui-react";
import moment from "moment";
import { getFullName } from "utils/displayName";
import { toast } from "react-toastify";
import CustomPagination from "components/CustomPagination";

const CampaignRecords = ({ records, campaign, getStatusFolder, loadListRecords }) => {
	const [moreInfos, setMoreInfos] = useState(false);
	return (
		<div>
			<h3>Enregistrements de la campagne {campaign.name}</h3>
			{campaign.stats && (
				<Statistic.Group>
					<Statistic>
						<Statistic.Value>{campaign.stats.all}</Statistic.Value>
						<Statistic.Label>patients</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>{campaign.stats.not_assigned}</Statistic.Value>
						<Statistic.Label>en attente d'assignation</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>{campaign.stats.done}</Statistic.Value>
						<Statistic.Label>dossiers terminés</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>{campaign.stats.new_records}</Statistic.Value>
						<Statistic.Label>dossiers en attente du patient</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>{campaign.stats.current}</Statistic.Value>
						<Statistic.Label>dossiers en cours</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>{campaign.stats.canceled}</Statistic.Value>
						<Statistic.Label>dossiers annulés</Statistic.Label>
					</Statistic>
				</Statistic.Group>
			)}
			{records && (
				<>
					<div style={{ textAlign: "right" }}>
						{" "}
						Voir plus d'infos
						<Checkbox
							style={{ padding: "4px", marginRight: "10px" }}
							slider
							checked={moreInfos}
							onChange={(e) => {
								setMoreInfos(!moreInfos);
							}}
						/>
					</div>
					<Table sortable celled fixed>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Patient</Table.HeaderCell>
								<Table.HeaderCell>Statut</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{records &&
								records.records &&
								records.records.map((record) => (
									<Table.Row key={`campaign-rec-${record.id}`}>
										<Table.Cell>
											<div style={{ display: "flex", flexDirection: "column" }}>
												<div>
													{record.birth_name?.toUpperCase()}
													{record?.last_name ? ` - ${record?.last_name?.toUpperCase()}` : ""} {record.first_name} (
													{record.gender ? record.gender : "Pas de sexe"}){" "}
												</div>
												{moreInfos && (
													<>
														<div>
															{record.birth_date ? record.birth_date : "Pas de date de naissance"} -{" "}
															{record.cns ? record.cns : "Pas de numéro de sécurité sociale"}
														</div>
														<div>
															{record.email ? record.email : "Pas d'email"} -{" "}
															{record.mobile_phone ? record.mobile_phone : "Pas de numéro de téléphone"}
														</div>
														<div>
															{record.checked_by_sec ? (
																<span>
																	<Icon color="green" name="check" />
																	Patient associé par une secrétaire
																</span>
															) : (
																<span>
																	<Icon color="orange" name="wait" />
																	Patient à associer
																</span>
															)}
														</div>
													</>
												)}
											</div>
										</Table.Cell>
										{!moreInfos && (
											<Table.Cell>
												<div>
													{record.folder ? (
														record.folder?.code.startsWith("TEMP") ? (
															<Label color="green">En attente du patient</Label>
														) : (
															<>
																<span>Dossier {record.folder?.code} </span>
																<Label color={record.folder.status === "DONE" ? "grey" : record.folder.status === "CANCELED" ? "brown" : "orange"}>
																	{getStatusFolder(record.folder)}
																</Label>
															</>
														)
													) : (
														<Label color="yellow">En attente d'assignation</Label>
													)}
												</div>
											</Table.Cell>
										)}
										{moreInfos && (
											<>
												<Table.Cell>
													<div>
														{record.folder ? (
															record.folder?.code.startsWith("TEMP") ? (
																<Label color="green">En attente du patient {`- Patient MyLab : ${getFullName(record.folder?.patient)}`}</Label>
															) : (
																<Label color={record.folder.status === "DONE" ? "grey" : record.folder.status === "CANCELED" ? "brown" : "orange"}>
																	Dossier{" "}
																	{`${record.folder?.code} - ${getStatusFolder(record.folder)} - Patient MyLab : ${getFullName(
																		record.folder?.patient
																	)}`}
																</Label>
															)
														) : (
															<>
																<Label color="yellow">En attente d'assignation</Label> <span>Dossier non créé</span>
															</>
														)}

														{record.folder && record.folder.labAppointment && (
															<div>
																<Label>{record.folder.labAppointment.center.name}</Label>
															</div>
														)}
														{record.folder &&
															record.folder.openedBy &&
															"Ouvert par " + record.folder.openedBy.first_name + " " + record.folder.openedBy.last_name}
													</div>
													{record.qr_code && (
														<div
															style={{ cursor: "copy", position: "inherit", padding: "0.5em", zIndex: 10 }}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																navigator.clipboard.writeText(record.qr_code);
																toast.success("QR code copié !");
															}}
														>
															<Icon name="qrcode" /> {record.qr_code}
														</div>
													)}
													<div>
														Ajouté le {moment(record.created_at).format("DD/MM/YYYY")} à {moment(record.created_at).format("HH:mm")}
													</div>
													{!moment(record.updated_at).isSame(moment(record.created_at)) && (
														<div>
															{record.folder
																? `Mis à jour le ${moment(record.folder.updated_at).format("DD/MM/YYYY")} à ${moment(record.folder.updated_at).format(
																		"HH:mm"
																  )}`
																: `Mis à jour le ${moment(record.updated_at).format("DD/MM/YYYY")} à ${moment(record.updated_at).format("HH:mm")}`}
														</div>
													)}
												</Table.Cell>
											</>
										)}
									</Table.Row>
								))}
						</Table.Body>
					</Table>
					{records.count > 20 && (
						<CustomPagination
							activePage={records.page}
							totalPages={Math.ceil(records.count / 20)}
							onPageChange={(e, { activePage }) => {
								loadListRecords(campaign.id, activePage);
							}}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default CampaignRecords;
